<!--
  - Copyright (C) 2024. Archimedes Exhibitions GmbH,
  - Saarbrücker Str. 24, Berlin, Germany
  -
  - This file contains proprietary source code and confidential
  - information. Its contents may not be disclosed or distributed to
  - third parties unless prior specific permission by Archimedes
  - Exhibitions GmbH, Berlin, Germany is obtained in writing. This applies
  - to copies made in any form and using any medium. It applies to
  - partial as well as complete copies.
  -->

<template>
  <div v-if="nodeTitle">
    <b-modal
      centered
      size="md"
      v-model="isQuestionShown"
      :title="$t('users.modals.deleteHead')"
      header-bg-variant="danger"
      header-text-variant="light"
      @ok="$emit('delete', uuid)"
      :ok-title="$t('users.modals.yes')"
      :cancel-title="$t('users.modals.cancel')"
      ok-variant="danger"
    >
      {{ $t('users.modals.deleteQuestion', { deleteName: nodeTitle }) }}
    </b-modal>

    <b-modal
      centered
      size="md"
      v-model="isWarningShown"
      :title="warningTitle"
      header-bg-variant="warning"
      ok-only
    >
      <div v-if="linkedNodes">
        <p>
          <b-icon-exclamation-triangle-fill></b-icon-exclamation-triangle-fill>
          {{ $t('users.modals.linkHint') }}
        </p>
        <hr />
        <b>{{ truncateString(nodeTitle) }}</b>
        <hr />
        <p>
          <b-icon-arrow-right-circle-fill></b-icon-arrow-right-circle-fill>
          {{ $t('users.modals.unlinkHint') }}
        </p>

        <b-list-group class="mt-1 mb-1">
          <b-list-group-item
            class="d-flex justify-content-between align-items-center"
            v-for="(node, i) in linkedNodes"
            :key="i"
            :to="getCmsRoute(node)"
          >
            {{ truncateString(node.displayName) }}
            ({{ getCmsRoute(node).query.lang }})
            <b-badge variant="primary">
              {{ node.schema.name }}
            </b-badge>
          </b-list-group-item>
        </b-list-group>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import { utils } from '@amdx/emslib'

  export default {
    name: 'DeleteDialog',
    data () {
      return {
        isQuestionShown: false,
        isWarningShown: false,
        warningTitle: this.$t('users.modals.notDeletable'),
        nodeTitle: null,
        linkedNodes: null,
        calendarUsage: null,
        uuid: null
      }
    },
    methods: {
      showQuestion (title, uuid) {
        this.isQuestionShown = true
        this.nodeTitle = title
        this.uuid = uuid
      },
      showLinkedWarning (title, linkedNodes, warningTitle = null) {
        this.isWarningShown = true
        this.nodeTitle = title
        this.linkedNodes = linkedNodes
        if (warningTitle) {
          this.warningTitle = warningTitle
        }
      },
      truncateString (text, maxLength = 100) {
        return utils.getTruncatedString(text, maxLength)
      },
      getCmsRoute (node) {
        let routeName =
          this.$cmsManager.getContainerName(node.parentNode.uuid) + '-edit'
        return {
          name: routeName,
          params: { uuid: node.uuid },
          query: {
            lang: node.language,
            parentUuid: node.parentNode.uuid
          }
        }
      }
    }
  }
</script>

<style scoped></style>
